module.exports = "<h2>Ranges</h2><pre class=\"fragment\"><code class=\"lang-kotlin\">1..10 step 2 // 2 4 6 8 10\n\n1 until 10 // 1 2 3 4 5 6 7 8 9 (Excludes 10)\n\n10..1 // Empty, range syntax only handles ascending values\n\n10 downTo 1   // 10 9 8 7 6 5 4 3 2 1</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-moar/01.pug
// module id = 331
// module chunks = 1